// extracted by mini-css-extract-plugin
export default {"content":"Question_content__KmL9L","question":"Question_question__4xJVT","desc":"Question_desc__GFI7b"};